module.exports = __webpack_public_path__ + "static/media/qa.c58b6395.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/qa.svg
// module id = 232
// module chunks = 0